/* HAIRPLUG theme JS */
(function(){
  var NEEDS={"beard-oil":["beard"],"volumising-dust":["volume"],"curl-cream-1":["curls"],"sea-salt-spray-1":["volume"],"pomade":["slick"],"paste":["hold"],"clay":["hold"],"texture-comb":["volume"],"the-flow-set":["slick","bundle"],"cream-styler":["slick"],"hair-spray":["volume","hold"],"lightwork":["slick"],"clay-pomade":["slick","hold"],"curl-cream":["curls"],"the-texture-set":["volume","bundle"],"sea-salt-spray":["volume"],"hair-styling-powder":["volume"],"the-comb-set":["slick","bundle"],"bleach-set":["blonde","bundle"],"bleaching-kit":["blonde"],"no-yellow-shampoo":["wash","blonde"],"no-yellow-conditioner":["wash","blonde"],"scalp-brush":["wash"],"hair-strength-gummies":["fill"],"scalp-scrub":["wash"],"detox-2-in-1-shampoo-and-conditioner":["wash"],"daily-2-in-1-shampoo-conditioner":["wash"],"daily-wash-moisturiser-set":["face","bundle"],"super-serum-and-gua-sha":["face","bundle"],"ultimate-skin-set":["face","bundle"],"gua-sha":["face"],"face-scrubber":["face"],"blemish-pimple-patches-36-pack":["face"],"skin-revive-sheet-masks-3-pack":["face"],"super-serum":["face"],"hydra-boost-under-eye-patches-3-set-pack":["face"],"daily-moisturiser":["face"],"daily-face-wash":["face"],"lightning-hair-building-fibers":["fill"],"minotaur-beard-oil-serum":["beard"],"power-bull-4-in-1-shampoo":["wash"],"white-end-anti-dandruff-shampoo":["wash"],"cool-bull-tonic-cleansing-spray":["wash"],"shades-clay":["hold"],"clay-play":["hold"],"bull-blaster-pomade":["slick"],"play-hard-paste":["hold"],"mattmeup-paste":["hold"],"bull-blaster-sea-salt-spray":["volume"],"space-dust-hair-powder":["volume","fill"],"c4-curl-cream-define-hydrate-control":["curls"],"funky-head-matte-paste":["hold"]};
  window.HP_NEEDS=NEEDS;
  var T=window.HP_T||{};
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* tape marquee: duplicate track content */
  document.querySelectorAll('.tape-track').forEach(function(m){m.innerHTML+=m.innerHTML;});

  /* reveal */
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.1});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
  } else { document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');}); }

  /* hero parallax + card tilt */
  var stage=document.getElementById('stage');
  if(!reduce && matchMedia('(hover:hover)').matches){
    if(stage){
      var fps=stage.querySelectorAll('.fp');
      addEventListener('mousemove',function(e){
        var r=stage.getBoundingClientRect(); if(r.bottom<0) return;
        var x=(e.clientX-(r.left+r.width/2))/r.width, y=(e.clientY-(r.top+r.height/2))/r.height;
        fps.forEach(function(f){var d=+f.dataset.depth; f.style.transform='translate('+(-x*d)+'px,'+(-y*d)+'px)';});
      });
    }
    document.addEventListener('mousemove',function(e){
      var c=e.target.closest('.tilt'); if(!c) return;
      var r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
      c.style.transform='translate(-4px,-4px) rotateX('+(-y*6)+'deg) rotateY('+(x*8)+'deg)';
    });
    document.addEventListener('mouseout',function(e){var c=e.target.closest('.tilt'); if(c && !c.contains(e.relatedTarget)) c.style.transform='';});
  }

  /* hero: product pictures change one card at a time */
  if(stage && !reduce){
    var cards=[].slice.call(stage.querySelectorAll('.fp')).filter(function(f){return f.querySelectorAll('img').length>1;});
    if(cards.length){
      var turn=0, every=Math.max(2,+stage.dataset.speed||3)*1000;
      setInterval(function(){
        if(document.hidden) return;
        var f=cards[turn%cards.length]; turn++;
        var imgs=f.querySelectorAll('img'), cur=f.querySelector('img.on'), i=[].indexOf.call(imgs,cur), nx=imgs[(i+1)%imgs.length];
        if(!nx.complete){ nx.loading='eager'; return; }
        cur.classList.remove('on'); nx.classList.add('on');
        f.href=nx.dataset.url; f.setAttribute('aria-label',nx.alt);
      },every);
    }
  }

  /* header: mark the menu link of the page you are on */
  (function(){ var here=location.pathname.replace(/^\/(lv|et|lt|ru|en)(?=\/|$)/,'')||'/', q=new URLSearchParams(location.search), b=q.get('brand');
    document.querySelectorAll('.nav a').forEach(function(a){ try{ var u=new URL(a.href,location.href), p=u.pathname.replace(/^\/(lv|et|lt|ru|en)(?=\/|$)/,'')||'/', ub=u.searchParams.get('brand');
      if(p===here && ((ub&&ub===b)||(!ub&&!b&&p!=='/'))) a.classList.add('on'); }catch(e){} }); })();

  /* burger */
  var burger=document.querySelector('.burger'),nav=document.querySelector('.nav');
  if(burger&&nav){
    burger.addEventListener('click',function(){var open=nav.classList.toggle('open');nav.style.cssText=open?'display:flex;flex-direction:column;position:absolute;left:0;right:0;top:100%;background:#0D0D0D;padding:18px 20px;gap:16px;border-bottom:1px solid rgba(255,255,255,.1)':'';});
    nav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){nav.classList.remove('open');nav.style.cssText='';});});
    /* close the phone menu when the page is scrolled or tapped outside the menu */
    var closeNav=function(){ if(nav.classList.contains('open')){ nav.classList.remove('open'); nav.style.cssText=''; } };
    var openY=0; burger.addEventListener('click',function(){ openY=scrollY; });
    addEventListener('scroll',function(){ if(nav.classList.contains('open')&&Math.abs(scrollY-openY)>40) closeNav(); },{passive:true});
    document.addEventListener('click',function(e){ if(nav.classList.contains('open')&&!nav.contains(e.target)&&!burger.contains(e.target)) closeNav(); });
  }

  /* header search panel with live product suggestions */
  var hs=document.getElementById('hsrch');
  if(hs){
    var hq=document.getElementById('hsrch-q'), hr=document.getElementById('hsrch-res'), hseq=0, ht;
    function isSearchLink(a){
      if(a.hasAttribute('data-search-open')) return true;
      if(!a.closest('.nav')) return false;
      try{ var u=new URL(a.getAttribute('href'),location.href); return u.origin===location.origin && /\/search\/?$/.test(u.pathname) && !u.search; }catch(err){ return false; }
    }
    function openS(){ hs.hidden=false; if(nav&&nav.classList.contains('open')){ nav.classList.remove('open'); nav.style.cssText=''; } setTimeout(function(){ hq.focus(); },30); }
    function closeS(){ hs.hidden=true; }
    function fmt(c){ var m=window.HP_MONEY||'€{{amount_with_comma_separator}}'; return m.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,(c/100).toFixed(2).replace('.',',')).replace(/\{\{\s*amount\s*\}\}/,(c/100).toFixed(2)).replace(/<[^>]*>/g,''); }
    function el(tag,cls,txt){ var x=document.createElement(tag); if(cls) x.className=cls; if(txt!=null) x.textContent=txt; return x; }
    function allUrl(q){ var f=hs.querySelector('form'); return f.getAttribute('action')+'?type=product&q='+encodeURIComponent(q); }
    function render(list,q){
      hr.innerHTML='';
      if(!list.length){ hr.appendChild(el('p','hs-none',hs.dataset.empty||'')); return; }
      list.forEach(function(p){
        var a=el('a','hs-i'); a.href=p.url;
        var im=el('span','im'); var src=(p.featured_image&&p.featured_image.url)||p.image;
        if(src){ var i=document.createElement('img'); i.src=src+(src.indexOf('?')>-1?'&':'?')+'width=140'; i.alt=''; i.loading='lazy'; im.appendChild(i); }
        var t=el('span'); t.appendChild(el('small',null,p.vendor||'')); t.appendChild(el('b',null,p.title||''));
        var pr=parseFloat(p.price); if(!isNaN(pr)) t.appendChild(el('em',null,fmt(Math.round(pr*100))));
        a.appendChild(im); a.appendChild(t); hr.appendChild(a);
      });
      var all=el('a','hs-all',hs.dataset.all||'See all'); all.href=allUrl(q); hr.appendChild(all);
    }
    function suggest(){
      var q=hq.value.trim(), my=++hseq;
      if(q.length<2){ hr.innerHTML=''; return; }
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(d){ if(my!==hseq) return; render((d&&d.resources&&d.resources.results&&d.resources.results.products)||[],q); })
        .catch(function(){ if(my===hseq) hr.innerHTML=''; });
    }
    hq.addEventListener('input',function(){ clearTimeout(ht); ht=setTimeout(suggest,200); });
    hs.querySelector('.hsrch-x').addEventListener('click',closeS);
    document.addEventListener('click',function(e){
      var a=e.target.closest('a');
      if(a&&isSearchLink(a)){ e.preventDefault(); if(hs.hidden) openS(); else closeS(); return; }
      if(!hs.hidden&&!hs.contains(e.target)) closeS();
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!hs.hidden) closeS(); });
  }

  /* cart pill + toast + ajax add */
  var cart=document.getElementById('cart'), cn=document.getElementById('cn'), toast=document.getElementById('toast');
  function setCount(n){ if(cn) cn.textContent=n; if(cart) cart.classList.toggle('show',n>0); }
  function say(msg){ if(!toast) return; toast.textContent=msg; toast.classList.add('on'); clearTimeout(say.t); say.t=setTimeout(function(){toast.classList.remove('on');},1400); }
  window.hpSay=say;
  function refresh(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count);return c;}); }
  window.hpRefreshCart=refresh;
  refresh();
  function add(id,qty){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
      .then(function(r){ if(!r.ok) return r.json().then(function(j){throw new Error(j.description||j.message||'error');}); return r.json(); })
      .then(function(){ say(T.added||'added ✓'); return refresh(); })
      .catch(function(e){ say(e.message||T.could_not_add||'could not add'); });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('.add[data-id]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    if(b.dataset.avail==='false'){ say(T.sold_out||'sold out'); return; }
    add(b.dataset.id,1);
  });

  /* product form */
  var pf=document.getElementById('pform');
  if(pf){
    var variants=JSON.parse(document.getElementById('pvariants').textContent);
    var idIn=pf.querySelector('[name="id"]'), btn=pf.querySelector('.buy .btn'), priceEl=document.getElementById('pprice'), cmpEl=document.getElementById('pcompare'), offEl=document.getElementById('poff');
    var qtyIn=pf.querySelector('.qty input');
    function money(c){ return (window.HP_MONEY||'€{{amount}}').replace('{{amount}}',(c/100).toFixed(2)).replace('{{amount_with_comma_separator}}',(c/100).toFixed(2).replace('.',',')); }
    function current(){
      var opts=pf.querySelectorAll('.opt');
      if(!opts.length){ return variants.filter(function(v){return String(v.id)===String(idIn.value);})[0]||variants[0]; }
      var sel=[].map.call(opts,function(o){var c=o.querySelector('input:checked');return c?c.value:null;});
      return variants.filter(function(v){return v.options.every(function(x,i){return x===sel[i];});})[0];
    }
    function sync(){
      var v=current();
      if(!v){ btn.disabled=true; btn.textContent=T.unavailable||'Unavailable'; return; }
      idIn.value=v.id;
      priceEl.textContent=money(v.price);
      if(cmpEl){ if(v.compare_at_price&&v.compare_at_price>v.price){cmpEl.textContent=money(v.compare_at_price);cmpEl.hidden=false; if(offEl){offEl.textContent='-'+Math.round((1-v.price/v.compare_at_price)*100)+'%';offEl.hidden=false;}} else {cmpEl.hidden=true; if(offEl) offEl.hidden=true;} }
      btn.disabled=!v.available; btn.textContent=v.available?(T.add_to_cart||'Add to cart'):(T.sold_out||'Sold out');
      if(v.featured_image){ var main=document.getElementById('pimg'); if(main) main.src=v.featured_image.src; }
      if(history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u); }
    }
    pf.querySelectorAll('.opt input').forEach(function(i){i.addEventListener('change',sync);});
    pf.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(){var n=Math.max(1,(+qtyIn.value||1)+(+b.dataset.d));qtyIn.value=n;});});
    pf.addEventListener('submit',function(e){ e.preventDefault(); var v=current(); if(!v||!v.available) return; btn.disabled=true; add(v.id,+qtyIn.value||1).then(function(){btn.disabled=false;}); });
    document.querySelectorAll('.pdp-thumbs button').forEach(function(t){t.addEventListener('click',function(){document.getElementById('pimg').src=t.dataset.src;document.querySelectorAll('.pdp-thumbs button').forEach(function(x){x.classList.toggle('on',x===t);});});});
    sync();
  }

  /* cart page */
  var cl=document.getElementById('cart-lines');
  if(cl){
    function change(line,qty){
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})})
        .then(function(r){return r.json();}).then(function(){location.reload();});
    }
    cl.addEventListener('click',function(e){
      var q=e.target.closest('[data-q]'); if(q){ var row=q.closest('.line'), inp=row.querySelector('input'); var n=Math.max(0,(+inp.value||1)+(+q.dataset.q)); change(+row.dataset.line,n); }
      var rm=e.target.closest('.rm'); if(rm){ e.preventDefault(); change(+rm.closest('.line').dataset.line,0); }
    });
    cl.querySelectorAll('input').forEach(function(i){i.addEventListener('change',function(){change(+i.closest('.line').dataset.line,Math.max(0,+i.value||0));});});
  }

  /* mobile swipe rows: arrow on the right of each product picture (CSS shows it on phones only) */
  var rows=document.querySelectorAll('.type-blk .grid, .more .grid');
  var ARROW='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="square" aria-hidden="true"><path d="M9 4l8 8-8 8"/></svg>';
  /* phone rows: no arrow; instead the card in view is bright and the others step back, with a yellow progress bar + 01 / 05 counter under the row */
  var phoneQ=window.matchMedia('(max-width:620px)');
  rows.forEach(function(g){
    if(g.nextElementSibling&&g.nextElementSibling.classList.contains('swp-bar')) return;
    var bar=document.createElement('div'); bar.className='swp-bar'; bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<span class="swp-tr"><i></i></span><b class="swp-n"></b><em class="swp-hint">'+(T.swipe||'Swipe')+'</em>';
    g.parentNode.insertBefore(bar,g.nextSibling);
    var fill=bar.querySelector('i'), num=bar.querySelector('.swp-n'), raf=0;
    function upd(){
      raf=0;
      var vis=[].filter.call(g.querySelectorAll('.prod'),function(p){return !p.classList.contains('hide');});
      var n=vis.length; bar.classList.toggle('one',n<2); g.classList.toggle('swp',phoneQ.matches&&n>1);
      if(!n) return;
      var pad=parseFloat(getComputedStyle(g).paddingLeft)||0, x=g.scrollLeft, cur=0, best=1e9;
      vis.forEach(function(p,i){var d=Math.abs(p.offsetLeft-pad-x); if(d<best){best=d;cur=i;}});
      if(g.scrollLeft+g.clientWidth>=g.scrollWidth-4) cur=n-1;
      vis.forEach(function(p,i){p.classList.toggle('cur',i===cur);});
      fill.style.width=((cur+1)/n*100)+'%';
      num.textContent=(cur+1<10?'0':'')+(cur+1)+' / '+(n<10?'0':'')+n;
      if(x>10) bar.classList.add('used');
    }
    g.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(upd); },{passive:true});
    window.addEventListener('resize',upd); g._swpUpd=upd; upd();
  });

  function marks(){
    rows.forEach(function(g){
      var vis=[].filter.call(g.querySelectorAll('.prod'),function(p){return !p.classList.contains('hide');});
      vis.forEach(function(p,i){p.classList.toggle('is-last',i===vis.length-1);});
      if(g._swpUpd) g._swpUpd();
    });
  }
  marks();
  document.addEventListener('click',function(e){
    var n=e.target.closest('.nx'); if(!n) return;
    e.preventDefault(); e.stopPropagation();
    var card=n.closest('.prod'), g=card&&card.parentNode; if(!g) return;
    var nx=card.nextElementSibling; while(nx&&nx.classList.contains('hide')) nx=nx.nextElementSibling;
    if(!nx) return;
    g.scrollTo({left:nx.offsetLeft-(parseFloat(getComputedStyle(g).paddingLeft)||0),behavior:reduce?'auto':'smooth'});
  });

  /* "We are the plug" product slideshow: plays on phone and computer, arrows, swipe and mouse drag */
  document.querySelectorAll('[data-slides]').forEach(function(box){
    var slides=[].slice.call(box.querySelectorAll('.ws-slide')); if(slides.length<2) return;
    var i=0, speed=(parseFloat(box.dataset.speed)||4)*1000, timer=null, onScreen=false, dragged=false;
    function show(n){
      slides[i].classList.remove('on'); slides[i].setAttribute('aria-hidden','true'); slides[i].tabIndex=-1;
      i=(n+slides.length)%slides.length;
      slides[i].classList.add('on'); slides[i].removeAttribute('aria-hidden'); slides[i].removeAttribute('tabindex');
      var nx=slides[(i+1)%slides.length].querySelector('img'); if(nx&&nx.loading==='lazy') nx.loading='eager';
    }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function start(){ stop(); if(!reduce&&onScreen) timer=setInterval(function(){ if(!document.hidden) show(i+1); },speed); }
    box.querySelector('.ws-next').addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); show(i+1); start(); this.blur(); });
    box.querySelector('.ws-prev').addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); show(i-1); start(); this.blur(); });
    var x0=null, y0=0;
    box.addEventListener('pointerdown',function(e){ if(e.button>0||e.target.closest('.ws-nav')) return; x0=e.clientX; y0=e.clientY; dragged=false; });
    box.addEventListener('pointermove',function(e){ if(x0!==null&&Math.abs(e.clientX-x0)>8){ dragged=true; box.classList.add('dragging'); } });
    function end(e){
      if(x0===null) return; var dx=e.clientX-x0, dy=e.clientY-y0; x0=null; box.classList.remove('dragging');
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){ show(dx<0?i+1:i-1); start(); }
    }
    box.addEventListener('dragstart',function(e){ e.preventDefault(); });
    box.addEventListener('pointerup',end); box.addEventListener('pointercancel',function(){ x0=null; box.classList.remove('dragging'); });
    box.addEventListener('click',function(e){ if(dragged){ e.preventDefault(); dragged=false; } },true);
    box.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){ show(i+1); start(); } if(e.key==='ArrowLeft'){ show(i-1); start(); } });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ en.forEach(function(x){ onScreen=x.isIntersecting; onScreen?start():stop(); }); },{threshold:.15}).observe(box);
    } else { onScreen=true; start(); }
  });

  /* "Pick yours" tiles: shrink a heading until its longest word fits (long Russian / Lithuanian words) */
  function fitNeeds(){
    var hs=document.querySelectorAll('.need h3'), min=999;
    hs.forEach(function(h){
      h.style.fontSize=''; var fs=parseFloat(getComputedStyle(h).fontSize), n=0;
      while(h.scrollWidth>h.clientWidth+1&&fs>14&&n<40){ fs-=1; h.style.fontSize=fs+'px'; n++; }
      if(fs<min) min=fs;
    });
    /* same size on every tile so they look balanced */
    hs.forEach(function(h){ h.style.fontSize=min+'px'; });
  }
  if(document.querySelector('.need h3')){
    fitNeeds();
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fitNeeds);
    var fitT; addEventListener('resize',function(){ clearTimeout(fitT); fitT=setTimeout(fitNeeds,150); });
  }

  /* collection filters */
  var cat=document.getElementById('catalog');
  if(cat){
    var NL=JSON.parse(document.getElementById('hp-nl').textContent);
    var F={brand:'all',need:'all'};
    var ps=new URLSearchParams(location.search);
    if(ps.get('brand')) F.brand=ps.get('brand'); if(ps.get('need')) F.need=ps.get('need');
    cat.querySelectorAll('.prod').forEach(function(p){
      var have=(p.dataset.needs||'').split(' ').filter(Boolean); if(!have.some(function(x){return x!=='clay'&&x!=='powder';})){ var n=(NEEDS[p.dataset.handle]||[]).slice(); if(p.dataset.bundle==='true'&&n.indexOf('bundle')<0) n=n.concat(['bundle']); p.dataset.needs=n.concat(have).join(' '); }
    });
    var hEl=document.getElementById('shop-h'), nEl=document.getElementById('shop-n');
    function count(t){
      var n=0; cat.querySelectorAll('.prod').forEach(function(p){
        if((t.brand==='all'||p.dataset.brand===t.brand)&&(t.need==='all'||(' '+p.dataset.needs+' ').indexOf(' '+t.need+' ')>-1)) n++;
      }); return n;
    }
    function apply(push){
      var any=0;
      cat.querySelectorAll('.prod').forEach(function(p){
        var ok=(F.brand==='all'||p.dataset.brand===F.brand)&&(F.need==='all'||(' '+p.dataset.needs+' ').indexOf(' '+F.need+' ')>-1);
        p.classList.toggle('hide',!ok); if(ok) any++;
      });
      cat.querySelectorAll('.type-blk').forEach(function(t){t.classList.toggle('hide',!t.querySelector('.prod:not(.hide)'));});
      cat.querySelectorAll('.brand-blk').forEach(function(b){b.classList.toggle('hide',!b.querySelector('.prod:not(.hide)'));});
      marks();
      var em=document.getElementById('empty'); if(em) em.classList.toggle('on',!any);
      document.querySelectorAll('.f').forEach(function(x){x.classList.toggle('on',F[x.dataset.k]===x.dataset.v);});
      /* grey out choices that would show nothing with the other filter as it is now */
      /* barber-tool brand (all its products are barber tools) or a tool choice: For shows Clippers / Trimmers / Shavers instead of hair choices */
      var TOOLS=['clipper','trimmer','shaver'];
      var toolMode=TOOLS.indexOf(F.need)>-1||F.need==='barber';
      if(F.brand!=='all'){ var bp=[].filter.call(cat.querySelectorAll('.prod'),function(p){return p.dataset.brand===F.brand;}); if(bp.length&&bp.every(function(p){return (' '+p.dataset.needs+' ').indexOf(' barber ')>-1;})) toolMode=true; }
      document.querySelectorAll('.f[data-k="need"]').forEach(function(x){
        var v=x.dataset.v, tool=TOOLS.indexOf(v)>-1, gone=v!=='all'&&(toolMode?(!tool&&!(v==='barber'&&F.need==='barber')):(tool||(v==='barber'&&F.brand!=='all')));
        x.classList.toggle('gone',gone);
      });
      document.querySelectorAll('.f').forEach(function(x){
        var k=x.dataset.k, v=x.dataset.v; if(v==='all'){ x.classList.remove('off'); x.disabled=false; return; }
        var t={brand:F.brand,need:F.need}; t[k]=v; var has=count(t)>0;
        x.classList.toggle('off',!has); x.disabled=!has;
      });
      document.querySelectorAll('[data-dd-val]').forEach(function(v){var on=document.querySelector('.f.on[data-k="'+v.dataset.ddVal+'"]'); if(on) v.textContent=on.textContent;});
      if(hEl&&hEl.dataset.dyn==='true'){
        var h=NL[F.need]||NL.all;
        hEl.innerHTML=(F.brand!=='all'&&F.need==='all')?F.brand.split(' ')[0]+' <span class="o">'+F.brand.split(' ').slice(1).join(' ')+'</span>':h[0];
        if(nEl) nEl.textContent=(F.brand!=='all'?F.brand+' · ':'')+h[1];
      }
      if(push&&history.replaceState){ var u=new URL(location.href); F.brand==='all'?u.searchParams.delete('brand'):u.searchParams.set('brand',F.brand); F.need==='all'?u.searchParams.delete('need'):u.searchParams.set('need',F.need); history.replaceState(null,'',u); }
    }
    document.querySelectorAll('.f').forEach(function(b){b.addEventListener('click',function(){
      F[b.dataset.k]=b.dataset.v;
      /* picked a brand/need that does not go with the other choice: reset the other one to All */
      if(count(F)===0){ F[b.dataset.k==='brand'?'need':'brand']='all'; }
      apply(true);});});
    var fbar=document.querySelector('.fbar');
    function ddClose(){ if(!fbar) return; fbar.classList.remove('dd-brand','dd-need'); fbar.querySelectorAll('.fdd-b').forEach(function(b){b.setAttribute('aria-expanded','false');}); }
    document.querySelectorAll('.fdd-b').forEach(function(b){b.addEventListener('click',function(e){
      e.stopPropagation(); var k=b.dataset.dd, open=fbar.classList.contains('dd-'+k); ddClose();
      if(!open){ fbar.classList.add('dd-'+k); b.setAttribute('aria-expanded','true'); }
    });});
    document.querySelectorAll('.f').forEach(function(b){b.addEventListener('click',ddClose);});
    document.addEventListener('click',function(e){ if(fbar&&!fbar.contains(e.target)) ddClose(); });
    /* open Brand / For list closes as soon as you scroll the page */
    var ddY=0;
    document.querySelectorAll('.fdd-b').forEach(function(b){b.addEventListener('click',function(){ ddY=window.scrollY; });});
    window.addEventListener('scroll',function(){ if(fbar&&(fbar.classList.contains('dd-brand')||fbar.classList.contains('dd-need'))&&Math.abs(window.scrollY-ddY)>30) ddClose(); },{passive:true});
    if(count(F)===0) F.need='all';
    apply(false);
  }
})();

/* top bar: mark the page as scrolled so the bar tightens into a floating pill */
(function(){var r=document.documentElement,on=false;function f(){var s=window.scrollY>30;if(s!==on){on=s;r.classList.toggle('hp-scrolled',s);}}window.addEventListener('scroll',f,{passive:true});f();})();

/* filter panel: mark it while it is stuck under the top bar so it can slim down */
(function(){var f=document.querySelector('.fbar');if(!f)return;var raf=0;function u(){raf=0;var t=parseFloat(getComputedStyle(f).top)||0;f.classList.toggle('stuck',f.getBoundingClientRect().top<=t+1&&window.scrollY>50);}window.addEventListener('scroll',function(){if(!raf)raf=requestAnimationFrame(u);},{passive:true});window.addEventListener('resize',u);u();})();
